import { CreateBase, Form, useGetIdentity } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { AutomationRuleInputs } from "./AutomationRuleInputs";

export const AutomationRuleCreate = () => {
  const { identity } = useGetIdentity();
  return (
    <CreateBase redirect="list">
      <div className="mt-2 flex max-w-md">
        <Form
          className="flex-1"
          defaultValues={{
            sales_id: identity?.id,
            trigger_type: "stage_change",
            action_type: "pcm.postcard",
            action_config: {},
            requires_approval: true,
            enabled: true,
          }}
        >
          <Card>
            <CardContent>
              <AutomationRuleInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
    </CreateBase>
  );
};
